import * as React from 'react';
import { Canceler } from 'axios';

import { ITableRowValue } from '../components/TableRow';
import { ITagGroup, ITagGroupsProps, ITagGroupsState } from './types';

import API from 'src/services/api';
import New from './components/New';
import Edit from './components/Edit';
import Subpage from '../components/Subpage';

export const tagGroupChoices = [
  {
    label: 'Allow',
    value: 'AllowDuplicate',
  },
  {
    label: 'Allow with warnings',
    value: 'AllowDuplicateWithWarnings',
  },
  {
    label: 'Deny',
    value: 'DenyDuplicate',
  },
];

const getChoiceLabel = (value: string) => {
  const found = tagGroupChoices.find((choice) => choice.value === value);
  return found ? found.label : value;
};

class TagGroups extends React.Component<ITagGroupsProps, ITagGroupsState> {
  reqCanceler: Canceler | null = null;

  state: ITagGroupsState = {
    items: [],
    isLoading: true,
  };

  async componentDidMount() {
    const { getData, cancel } = API.ADMIN.TAG_GROUPS.getAll();
    this.reqCanceler = cancel;
    const items = await getData();
    this.reqCanceler = null;
    this.setState({ items, isLoading: false });
  }
  componentWillUnmount() {
    if (this.reqCanceler) {
      this.reqCanceler();
    }
  }

  columns: ITableRowValue[] = [
    'Name',
    [
      'Duplicate Tags for Items',
      'Select here if duplicate tag values are allowed on item-level or not',
    ],
    [
      'Duplicate Tags for Parameters',
      'Select here if duplicate tag values are allowed on parameter-level or not',
    ],
    [
      'Duplicate Tags in System',
      'Select here if duplicate tag values are allowed on system-level or not',
    ],
    [
      'Regular Expression',
      'Please add the Regular Expression (RegEx) here, which will restrict the format and length of the tag value that can be added in the interface. Example: ^[a-zA-Z0-9]{1,4}$ -> only tag values that are letters (lower case and higher case), numbers, or a minus sign, and which are not longer than 4 characters can be added.',
    ],
  ];

  getColumnValues = (tagGroup: ITagGroup) => [
    tagGroup.name,
    getChoiceLabel(tagGroup.allowDuplicateOnItemLevel),
    getChoiceLabel(tagGroup.allowDuplicateOnParameterLevel),
    getChoiceLabel(tagGroup.allowDuplicateInSystem),
    tagGroup.regexMatch || '—',
  ];

  getSearchString = (tagGroup: ITagGroup) => tagGroup.name;

  add = async (item: ITagGroup) => {
    const newItem = await API.ADMIN.TAG_GROUPS.add(item);
    this.setState(({ items }) => ({
      items: [newItem, ...items],
    }));
  };

  update = async (item: ITagGroup) => {
    const updatedItem = await API.ADMIN.TAG_GROUPS.update(item);
    this.setState(({ items }) => {
      const userIndex = items.findIndex((el) => el.id === updatedItem.id);
      return {
        items: [
          ...items.slice(0, userIndex),
          updatedItem,
          ...items.slice(userIndex + 1),
        ],
      };
    });
  };

  NewForm = (props: any) => {
    return <New add={this.add} allItems={this.state.items} {...props} />;
  };

  EditForm = (props: any) => {
    return <Edit allItems={this.state.items} update={this.update} {...props} />;
  };

  render() {
    return (
      <Subpage
        currentPath={this.props.location.pathname}
        NewForm={this.NewForm}
        EditForm={this.EditForm}
        columns={this.columns}
        getColumnValues={this.getColumnValues}
        getSearchString={this.getSearchString}
        items={this.state.items}
        isLoading={this.state.isLoading}
      />
    );
  }
}

export default TagGroups;



// WEBPACK FOOTER //
// ./src/views/Admin/TagGroups/TagGroups.tsx